<template>
    <div>
        <button class="ds-btn mr-1" @click="showModal">Pievienot lietotāju</button>

        <b-modal :visible="isModalVisible" @hidden="hideModal" hide-footer no-close-on-backdrop body-class="p-2" header-class="bg-light align-items-center" size="lg">
            <div slot="modal-title">
                <h3 class="h4 text-dark font-weight-light m-0">
                    {{ selectedUser._id ? 'Rediģēt' : 'Pievienot' }}
                </h3>
            </div>
            <div slot="modal-header-close">
            </div>
            <UsersBaseForm @finished="handleUserCreation"/>
        </b-modal>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import UsersBaseForm from './UsersBaseForm';
    import * as userStoreTypes from '../../vuex/modules/user/user.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import * as authStoreTypes from '../../vuex/modules/auth/auth.store-types';

    export default {
        name: 'users-add',
        components: {UsersBaseForm},
        computed: {
            ...mapGetters('user', {
                /** @type {User|*} */
                selectedUser: userStoreTypes.GET_SELECTED_USER,
                /** @type {boolean|*} */
                isModalVisible: userStoreTypes.GET_IS_MODAL_VISIBLE,
            }),
            ...mapGetters('auth', {
                /** @type {CurrentUser|*} */
                currentUser: authStoreTypes.GET_CURRENT_USER,
            }),
        },
        methods: {
            ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyUsers: companyStoreTypes.SET_CURRENT_COMPANY_USERS,
            }),
            ...mapActions('user', {
                /** @type {function|*} */
                getUsers: userStoreTypes.ACTION_GET_USERS,
                /** @type {function|*} */
                showModal: userStoreTypes.ACTION_SHOW_MODAL,
                /** @type {function|*} */
                hideModal: userStoreTypes.ACTION_HIDE_MODAL,
            }),
            async handleUserCreation() {
                this.hideModal();
                const users = await this.getUsers({companyId: this.$route.params.companyId || this.currentUser.company._id});
                this.setCurrentCompanyUsers(users);
            },
        },
    }
</script>